let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fl3hD")).then(() => parcelRequire('1nmnc'));